import React from 'react';
import { Box, Typography } from '@mui/material';

export const Collections: React.FC = () => {
  return (
    <Box sx={{ p: { xs: '10px', md: '20px' } }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
        Collections
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Coming soon.
      </Typography>
    </Box>
  );
};


